import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";
import ContactForm from "../../Components/ContactForm";

function Contact(): JSX.Element {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Contact Us
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Have feedback, found a bug, or want to request a feature? We'd love to
          hear from you!
        </Typography>
      </Box>

      <Paper elevation={3} sx={{ p: 4, maxWidth: 600, mx: "auto" }}>
        <ContactForm />
      </Paper>
    </Container>
  );
}

export default Contact;
